"use client";

import { c as _c } from "react/compiler-runtime";
import { CustomImage } from "@repo/design-system/components/ui/custom-image";
import { CustomLink } from "@repo/design-system/components/ui/custom-link";
import { cn } from "@repo/design-system/utils/cn";
import { useEffect, useState } from "react";
import { LanguageSwitcher } from "~/components/ui/language-switcher-eon";
import useToggleAnimationState from "~/hooks/use-toggle-animation-state";
import { useLanguage } from "~/translations/loader/use-language";
export default function HeaderMainEcon() {
  const $ = _c(101);
  const [height, setHeight] = useState(0);
  const t = useLanguage();
  const [showMenuCareer, renderMenuCareer, handleTransitionEndMenuCareer, toggleMenuCareer, closeMenuCareer] = useToggleAnimationState();
  const [showMobileMenuCareer, renderMobileMenuCareer, handleTransitionEndMobileMenuCareer, toggleMobileMenuCareer, closeMobileMenuCareer] = useToggleAnimationState();
  let t0;
  if ($[0] !== closeMobileMenuCareer) {
    t0 = newState => {
      closeMobileMenuCareer();
      document.body.style.overflow = newState ? "hidden" : "auto";
    };
    $[0] = closeMobileMenuCareer;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const [showMobileMenu, renderMobileMenu, handleTransitionEndMobileMenu, toggleMobileMenu, closeMobileMenu] = useToggleAnimationState(t0);
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setHeight(window.innerHeight);
    };
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== showMobileMenu) {
    t2 = [showMobileMenu];
    $[3] = showMobileMenu;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  useEffect(t1, t2);
  const careerItems = [[[t.header_career1_item1, t.header_career1_link1], [t.header_career1_item2, t.header_career1_link2], [t.header_career1_item3, t.header_career1_link3], [t.header_career1_item4, t.header_career1_link4], [t.header_career1_item5, t.header_career1_link5], [t.header_career1_item6, t.header_career1_link6]], [[t.header_career3_item1, t.header_career3_link1], [t.header_career3_item2, t.header_career3_link2], [t.header_career3_item3, t.header_career3_link3], [t.header_career3_item4, t.header_career3_link4], [t.header_career3_item5, t.header_career3_link5], [t.header_career3_item6, t.header_career3_link6]]];
  const createMenuItems = careerNumber => careerItems[careerNumber].map(item => <li className={cn(showMobileMenu && "border-gray-200 border-b", "mb-2")} key={item[0]}><CustomLink blank={true} className="hover:underline" data-source="lc" href={item[1]}>{item[0]}</CustomLink></li>);
  let t3;
  if ($[5] !== closeMenuCareer) {
    t3 = () => {
      setTimeout(() => closeMenuCareer(), 500);
    };
    $[5] = closeMenuCareer;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const handleMouseLeave = t3;
  let t4;
  let t5;
  if ($[7] !== closeMobileMenu || $[8] !== renderMobileMenu) {
    t4 = () => {
      if (!renderMobileMenu) {
        return;
      }
      const onKeyDown = event => {
        if (event.code === "Escape") {
          closeMobileMenu();
        }
      };
      document.body.addEventListener("keydown", onKeyDown);
      return () => document.body.removeEventListener("keydown", onKeyDown);
    };
    t5 = [renderMobileMenu, closeMobileMenu];
    $[7] = closeMobileMenu;
    $[8] = renderMobileMenu;
    $[9] = t4;
    $[10] = t5;
  } else {
    t4 = $[9];
    t5 = $[10];
  }
  useEffect(t4, t5);
  let t6;
  let t7;
  if ($[11] !== closeMenuCareer || $[12] !== renderMenuCareer) {
    t6 = () => {
      if (!renderMenuCareer) {
        return;
      }
      const onKeyDown_0 = event_0 => {
        if (event_0.code === "Escape") {
          closeMenuCareer();
        }
      };
      document.body.addEventListener("keydown", onKeyDown_0);
      return () => document.body.removeEventListener("keydown", onKeyDown_0);
    };
    t7 = [renderMenuCareer, closeMenuCareer];
    $[11] = closeMenuCareer;
    $[12] = renderMenuCareer;
    $[13] = t6;
    $[14] = t7;
  } else {
    t6 = $[13];
    t7 = $[14];
  }
  useEffect(t6, t7);
  const t8 = "sticky top-0 z-60 w-full bg-white print:hidden";
  const t9 = "relative w-full border-gray-200 border-b-4 px-6 md:px-10";
  const t10 = "mx-auto flex h-16 max-w-screen-xl justify-between text-center";
  let t11;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <span className="sr-only">Toggle mobile menu</span>;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  const t12 = showMobileMenu && "translate-y-2 rotate-45";
  let t13;
  if ($[16] !== t12) {
    t13 = cn(t12, "absolute top-0 block w-full border-foreground border-t-2 transition-all duration-300");
    $[16] = t12;
    $[17] = t13;
  } else {
    t13 = $[17];
  }
  let t14;
  if ($[18] !== t13) {
    t14 = <span className={t13} />;
    $[18] = t13;
    $[19] = t14;
  } else {
    t14 = $[19];
  }
  const t15 = showMobileMenu && "opacity-0";
  let t16;
  if ($[20] !== t15) {
    t16 = cn(t15, "absolute top-1/2 block w-full border-foreground border-t-2 transition-all");
    $[20] = t15;
    $[21] = t16;
  } else {
    t16 = $[21];
  }
  let t17;
  if ($[22] !== t16) {
    t17 = <span className={t16} />;
    $[22] = t16;
    $[23] = t17;
  } else {
    t17 = $[23];
  }
  const t18 = showMobileMenu && "-translate-y-2 -rotate-45";
  let t19;
  if ($[24] !== t18) {
    t19 = cn(t18, "absolute top-full block w-full border-foreground border-t-2 transition-all duration-300");
    $[24] = t18;
    $[25] = t19;
  } else {
    t19 = $[25];
  }
  let t20;
  if ($[26] !== t19) {
    t20 = <span className={t19} />;
    $[26] = t19;
    $[27] = t20;
  } else {
    t20 = $[27];
  }
  let t21;
  if ($[28] !== t14 || $[29] !== t17 || $[30] !== t20) {
    t21 = <div className="relative top-6 left-6 h-4 w-6">{t14}{t17}{t20}</div>;
    $[28] = t14;
    $[29] = t17;
    $[30] = t20;
    $[31] = t21;
  } else {
    t21 = $[31];
  }
  let t22;
  if ($[32] !== t21 || $[33] !== toggleMobileMenu) {
    t22 = <button className="absolute top-0 left-0 flex h-full w-16 lg:hidden" onClick={toggleMobileMenu} type="button">{t11}{t21}</button>;
    $[32] = t21;
    $[33] = toggleMobileMenu;
    $[34] = t22;
  } else {
    t22 = $[34];
  }
  let t23;
  if ($[35] !== t.header_navItem1 || $[36] !== t.header_navLink1) {
    t23 = <li className="flex h-full"><CustomLink blank={true} className="-ml-4 flex items-center px-3 hover:bg-[#f6f6f7] xl:px-4" data-source="lc" href={t.header_navLink1}>{t.header_navItem1}</CustomLink></li>;
    $[35] = t.header_navItem1;
    $[36] = t.header_navLink1;
    $[37] = t23;
  } else {
    t23 = $[37];
  }
  let t24;
  if ($[38] !== t.header_navItem2 || $[39] !== t.header_navLink2) {
    t24 = <li className="flex h-full"><CustomLink blank={true} className="flex h-full items-center px-3 hover:bg-[#f6f6f7] xl:px-4" data-source="lc" href={t.header_navLink2}>{t.header_navItem2}</CustomLink></li>;
    $[38] = t.header_navItem2;
    $[39] = t.header_navLink2;
    $[40] = t24;
  } else {
    t24 = $[40];
  }
  let t25;
  if ($[41] !== t.header_navItem3 || $[42] !== t.header_navLink3) {
    t25 = <li className="flex h-full"><CustomLink blank={true} className="flex h-full items-center px-3 hover:bg-[#f6f6f7] xl:px-4" data-source="lc" href={t.header_navLink3}>{t.header_navItem3}</CustomLink></li>;
    $[41] = t.header_navItem3;
    $[42] = t.header_navLink3;
    $[43] = t25;
  } else {
    t25 = $[43];
  }
  let t26;
  if ($[44] !== t.header_navItem4 || $[45] !== t.header_navLink4) {
    t26 = <li className="flex h-full"><CustomLink blank={true} className="flex h-full items-center px-2 hover:bg-[#f6f6f7] xl:px-4" data-source="lc" href={t.header_navLink4}>{t.header_navItem4}</CustomLink></li>;
    $[44] = t.header_navItem4;
    $[45] = t.header_navLink4;
    $[46] = t26;
  } else {
    t26 = $[46];
  }
  const t27 = showMenuCareer && "box-content border-gray-300 border-b-4 bg-[#f6f6f7]";
  let t28;
  if ($[47] !== t27) {
    t28 = cn(t27, "box-border flex h-full items-center px-3 hover:bg-[#f6f6f7] xl:px-2");
    $[47] = t27;
    $[48] = t28;
  } else {
    t28 = $[48];
  }
  let t29;
  if ($[49] !== t.header_navItem5 || $[50] !== t28) {
    t29 = <span className={t28} data-source="lc">{t.header_navItem5}</span>;
    $[49] = t.header_navItem5;
    $[50] = t28;
    $[51] = t29;
  } else {
    t29 = $[51];
  }
  let t30;
  if ($[52] !== showMenuCareer || $[53] !== t29 || $[54] !== toggleMenuCareer) {
    t30 = <button aria-expanded={showMenuCareer} onClick={toggleMenuCareer} type="button">{t29}</button>;
    $[52] = showMenuCareer;
    $[53] = t29;
    $[54] = toggleMenuCareer;
    $[55] = t30;
  } else {
    t30 = $[55];
  }
  const t31 = renderMenuCareer && <div className={cn("!z-10 absolute top-full left-0 mt-1 hidden h-auto w-full text-left lg:flex")} onTransitionEnd={handleTransitionEndMenuCareer}><div className="w-full overflow-hidden"><div className={cn(showMenuCareer ? "-translate-y-0" : "-translate-y-full", "flex w-full justify-between bg-[#f6f6f7] shadow-xl transition-all duration-700")}><div className="mx-auto mb-4 grid w-full max-w-screen-xl grid-flow-col grid-cols-3 gap-x-8 px-6 pt-6 text-[1.35rem]"><section className="flex flex-col gap-y-2 font-bold">{t.header_career1_title}<ul className="font-light text-lg">{createMenuItems(0)}</ul></section><section className="flex flex-col gap-y-2 pb-4 font-bold">{t.header_career3_title}<ul className="font-light text-lg">{createMenuItems(1)}</ul></section></div></div></div></div>;
  let t32;
  if ($[56] !== t30 || $[57] !== t31) {
    t32 = <li className="flex h-full">{t30}{t31}</li>;
    $[56] = t30;
    $[57] = t31;
    $[58] = t32;
  } else {
    t32 = $[58];
  }
  let t33;
  if ($[59] !== t.header_navItem6 || $[60] !== t.header_navLink6) {
    t33 = <li className="flex h-full"><CustomLink blank={true} className="flex h-full items-center px-2 hover:bg-[#f6f6f7] xl:px-4" data-source="lc" href={t.header_navLink6}>{t.header_navItem6}</CustomLink></li>;
    $[59] = t.header_navItem6;
    $[60] = t.header_navLink6;
    $[61] = t33;
  } else {
    t33 = $[61];
  }
  let t34;
  if ($[62] !== t23 || $[63] !== t24 || $[64] !== t25 || $[65] !== t26 || $[66] !== t32 || $[67] !== t33) {
    t34 = <ul className="relative hidden h-16 items-center text-lg leading-4 lg:flex">{t23}{t24}{t25}{t26}{t32}{t33}</ul>;
    $[62] = t23;
    $[63] = t24;
    $[64] = t25;
    $[65] = t26;
    $[66] = t32;
    $[67] = t33;
    $[68] = t34;
  } else {
    t34 = $[68];
  }
  let t35;
  if ($[69] !== t22 || $[70] !== t34) {
    t35 = <div className="flex h-full w-full justify-end lg:justify-between">{t22}{t34}</div>;
    $[69] = t22;
    $[70] = t34;
    $[71] = t35;
  } else {
    t35 = $[71];
  }
  const t36 = renderMobileMenu && <div className="mt-1 -ml-6 md:-ml-10"><button aria-hidden={true} className={cn(showMobileMenu ? "-translate-x-0 opacity-60" : "-translate-x-full opacity-0", "absolute w-full cursor-default bg-black transition-opacity duration-700 lg:hidden")} onClick={closeMobileMenu} style={{
      minHeight: height
    }} tabIndex={-1} type="button" /><div className={cn(showMobileMenu ? "-translate-x-0" : "-translate-x-full", "left-0 w-[296px] overflow-y-auto overflow-x-hidden bg-[#f6f6f7] transition-all duration-700 md:w-[305px] lg:hidden")} onTransitionEnd={handleTransitionEndMobileMenu} style={{
      minHeight: height - 68
    }}><div className="pt-0"><ul className={cn("text-lg leading-4 transition-all duration-300")}><li className="border-gray-200 border-b"><CustomLink blank={true} className="flex justify-between px-4 py-3 leading-6" data-source="lc" href={t.header_navLink1}><span data-source="lc">{t.header_navItem1}</span><CustomImage height={24} src="images/icons/chevron_bold_right.svg" width={20} /></CustomLink></li><li className="border-gray-200 border-b"><CustomLink blank={true} className="flex justify-between px-4 py-3 leading-6" data-source="lc" href={t.header_navLink2}><span data-source="lc">{t.header_navItem2}</span><CustomImage height={24} src="images/icons/chevron_bold_right.svg" width={20} /></CustomLink></li><li className="border-gray-200 border-b"><CustomLink blank={true} className="flex justify-between px-4 py-3 leading-6" data-source="lc" href={t.header_navLink3}><span data-source="lc">{t.header_navItem3}</span><CustomImage height={24} src="images/icons/chevron_bold_right.svg" width={20} /></CustomLink></li><li className="border-gray-200 border-b"><CustomLink blank={true} className="flex justify-between px-4 py-3 leading-6" data-source="lc" href={t.header_navLink4}><span data-source="lc">{t.header_navItem4}</span><CustomImage height={24} src="images/icons/chevron_bold_right.svg" width={20} /></CustomLink></li><li className="border-gray-200 border-b"><button className="w-full px-4 py-3 leading-6" data-source="lc" onClick={toggleMobileMenuCareer} type="button"><span className="flex justify-between"><span data-source="lc">{t.header_navItem5}</span><CustomImage height={24} src="images/icons/chevron_bold_right.svg" width={20} /></span></button>{renderMobileMenuCareer && <div className={cn(showMobileMenuCareer && "-translate-x-full", "absolute top-0 left-full h-[1050px] w-full bg-[#f6f6f7] text-left text-2xl transition-all duration-700")} onTransitionEnd={handleTransitionEndMobileMenuCareer}><button aria-label={t.header_back_button_title} className="sticky mb-3 flex w-full items-center gap-x-2 px-6 py-2 font-extrabold text-2xl" data-source="lc" onClick={closeMobileMenuCareer} title={t.header_back_button_title} type="button"><CustomImage className="rotate-180" height={24} src="images/icons/chevron_bold_right.svg" width={20} /><span data-source="lc">{t.header_navItem5}</span></button><section className="flex flex-col gap-y-2 px-6 pb-4 font-bold">{t.header_career1_title}<ul className="pl-4 font-light text-lg">{createMenuItems(0)}</ul></section><section className="flex flex-col gap-y-2 px-6 pb-4 font-bold">{t.header_career3_title}<ul className="pl-4 font-light text-lg">{createMenuItems(1)}</ul></section></div>}</li><li className="border-gray-200 border-b"><CustomLink blank={true} className="flex justify-between px-4 py-3 leading-6" data-source="lc" href={t.header_navLink6}><span data-source="lc">{t.header_navItem6}</span><CustomImage height={24} src="images/icons/chevron_bold_right.svg" width={20} /></CustomLink></li></ul></div></div></div>;
  let t37;
  if ($[72] !== t35 || $[73] !== t36) {
    t37 = <nav>{t35}{t36}</nav>;
    $[72] = t35;
    $[73] = t36;
    $[74] = t37;
  } else {
    t37 = $[74];
  }
  let t38;
  if ($[75] === Symbol.for("react.memo_cache_sentinel")) {
    t38 = <LanguageSwitcher />;
    $[75] = t38;
  } else {
    t38 = $[75];
  }
  let t39;
  if ($[76] === Symbol.for("react.memo_cache_sentinel")) {
    t39 = <CustomImage height={28} src="images/logo/logo_color.svg" width={96} />;
    $[76] = t39;
  } else {
    t39 = $[76];
  }
  let t40;
  if ($[77] !== t.header_home) {
    t40 = <div className="absolute top-0 right-6 flex h-full items-center justify-center gap-5 md:right-10 md:items-center lg:static">{t38}<CustomLink aria-label={t.header_home} className="-mb-1" data-source="lc" href="/" passParams={true} prefetch={false} title={t.header_home}>{t39}</CustomLink></div>;
    $[77] = t.header_home;
    $[78] = t40;
  } else {
    t40 = $[78];
  }
  let t41;
  if ($[79] !== t37 || $[80] !== t40) {
    t41 = <div className={t10}>{t37}{t40}</div>;
    $[79] = t37;
    $[80] = t40;
    $[81] = t41;
  } else {
    t41 = $[81];
  }
  let t42;
  if ($[82] !== handleMouseLeave || $[83] !== t41) {
    t42 = <div className={t9} onMouseLeave={handleMouseLeave}>{t41}</div>;
    $[82] = handleMouseLeave;
    $[83] = t41;
    $[84] = t42;
  } else {
    t42 = $[84];
  }
  let t43;
  if ($[85] !== t.econ_header_link1 || $[86] !== t.econ_header_title1) {
    t43 = <li className="flex h-full"><CustomLink blank={true} className="-ml-4 flex h-full items-center px-3 hover:bg-[#e8e8e8] xl:px-4" data-source="lc" href={t.econ_header_link1}>{t.econ_header_title1}</CustomLink></li>;
    $[85] = t.econ_header_link1;
    $[86] = t.econ_header_title1;
    $[87] = t43;
  } else {
    t43 = $[87];
  }
  let t44;
  if ($[88] !== t.econ_header_link2 || $[89] !== t.econ_header_title2) {
    t44 = <li className="flex h-full"><CustomLink blank={true} className="flex h-full items-center px-3 hover:bg-[#e8e8e8] xl:px-4" data-source="lc" href={t.econ_header_link2}>{t.econ_header_title2}</CustomLink></li>;
    $[88] = t.econ_header_link2;
    $[89] = t.econ_header_title2;
    $[90] = t44;
  } else {
    t44 = $[90];
  }
  let t45;
  if ($[91] !== t.econ_header_link3 || $[92] !== t.econ_header_title3) {
    t45 = <li className="flex h-full"><CustomLink blank={true} className="flex h-full items-center px-3 hover:bg-[#e8e8e8] xl:px-4" data-source="lc" href={t.econ_header_link3}>{t.econ_header_title3}</CustomLink></li>;
    $[91] = t.econ_header_link3;
    $[92] = t.econ_header_title3;
    $[93] = t45;
  } else {
    t45 = $[93];
  }
  let t46;
  if ($[94] !== t43 || $[95] !== t44 || $[96] !== t45) {
    t46 = <div className="relative w-full border-gray-200 border-b-4 bg-[#F6F6F7] px-6 text-[#727475] text-lg md:px-10"><div className="mx-auto flex h-16 max-w-screen-xl justify-between text-center"><ul className="flex h-full w-full items-center">{t43}{t44}{t45}</ul></div></div>;
    $[94] = t43;
    $[95] = t44;
    $[96] = t45;
    $[97] = t46;
  } else {
    t46 = $[97];
  }
  let t47;
  if ($[98] !== t42 || $[99] !== t46) {
    t47 = <header className={t8}>{t42}{t46}</header>;
    $[98] = t42;
    $[99] = t46;
    $[100] = t47;
  } else {
    t47 = $[100];
  }
  return t47;
}